/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Design_Settings_DescInputs */

const en_admin_design_settings_desc = /** @type {(inputs: Admin_Design_Settings_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Customize the colors of the Matching Week. Changes apply to the whole application including the login page.`)
};

const de_admin_design_settings_desc = /** @type {(inputs: Admin_Design_Settings_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passen Sie die Farben der Matching Week an. Die Änderungen gelten für die gesamte Anwendung inklusive Login-Seite.`)
};

/**
* | output |
* | --- |
* | "Customize the colors of the Matching Week. Changes apply to the whole application including the login page." |
*
* @param {Admin_Design_Settings_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_design_settings_desc = /** @type {((inputs?: Admin_Design_Settings_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Design_Settings_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_design_settings_desc(inputs)
	return en_admin_design_settings_desc(inputs)
});